import type { NegativeNews } from '@gcv/shared';
import type { QueryClient } from '@tanstack/react-query';

import { NEGATIVE_NEWS_KEY } from 'tanstack-hooks/keys';

export function updateNegativeNewsCache(
  queryClient: QueryClient,
  record: NegativeNews,
  changes: Partial<NegativeNews>
) {
  queryClient.setQueriesData({ queryKey: [NEGATIVE_NEWS_KEY] }, (records?: NegativeNews[]) =>
    records?.map((r) =>
      r.source_story_id === record.source_story_id && r.sp_id === record.sp_id && r.crb_id === record.crb_id
        ? { ...r, ...changes }
        : r
    )
  );
}
